<template>
  <div class="cover">
    <div :class="['circle', { orange: isDsr, blue: !isDsr }]">
      <PulseContractsIcon v-if="isDsr" />
      <PulseRoomIcon v-else />
    </div>
    <FriedH2 class="switch-text">{{
      isDsr ? $t('switching-to-contracts') : $t('switching-to-digital-sales-room')
    }}</FriedH2>
    <FriedParagraph class="create-text">{{ $t('create-something-great-today') }}</FriedParagraph>
    <FriedGetAcceptLogo class="logo" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, computed } from 'vue';
import { ModuleName } from '@getaccept/lib-shared/src/entity/app-modules/enums/app-module';
import PulseContractsIcon from '../assets/pulse-contracts.svg';
import PulseRoomIcon from '../assets/pulse-room.svg';

export default defineComponent({
  name: 'LoadProductScreen',
  components: {
    PulseContractsIcon,
    PulseRoomIcon,
  },
  props: {
    activeModule: { type: String as PropType<ModuleName>, required: true },
  },
  setup(props) {
    const isDsr = computed(() => props.activeModule === ModuleName.DealRooms);

    return { ModuleName, isDsr };
  },
});
</script>

<style lang="scss" scoped>
.cover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: var(--gray-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: $z-alert;
}

.circle {
  border-radius: 50%;
  min-height: 167px;
  min-width: 167px;
  transform: scale(1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30vh;

  &.orange {
    background: var(--signature-gradient-light);
    box-shadow: 0 0 0 0 rgb($signature-gradient-light, 100%);
    animation: pulse-orange 0.75s infinite;
  }

  &.blue {
    background: var(--base-blue);
    box-shadow: 0 0 0 0 rgb($base-blue, 100%);
    animation: pulse-blue 0.75s infinite;
  }
}

h2.switch-text {
  margin-top: 4vh;
  margin-bottom: var(--spacing-100);
}

.logo {
  margin-top: 29vh;
  width: 7.625rem;
}

@keyframes pulse-blue {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgb($base-blue, 70%);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 30px rgb($base-blue, 0%);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgb($base-blue, 0%);
  }
}

@keyframes pulse-orange {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgb($signature-gradient-light, 70%);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 30px rgb($signature-gradient-light, 0%);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba($signature-gradient-light, 0%);
  }
}
</style>
